import styled from 'styled-components'
import { Select, Button } from 'antd'

// Altura, raio, padding e placeholder vêm do tema (src/theme). Aqui só o
// que é específico deste formulário.
export const ClientSearchContainer = styled.div``

export const UniformFormWrapper = styled.div`
  .ant-form-item-label > label {
    font-weight: 600;
    color: var(--yrm-text);
  }

  /* Campos preenchidos automaticamente (somente leitura) */
  .ant-input[disabled] {
    color: rgba(0, 0, 0, 0.75);
  }
`

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$cols || 2}, minmax(0, 1fr));
  column-gap: 16px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`

export const SectionTitle = styled.h4`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0 12px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--yrm-text-3);
`

export const DrawerContainer = styled.div`
  .ant-drawer {
    position: fixed !important;
    top: 64px !important;
    height: calc(100vh - 64px) !important;
    z-index: 900 !important;
  }
  
  .ant-drawer-content-wrapper {
    height: 100% !important;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15) !important;
  }
  
  .ant-drawer-content {
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  .ant-drawer-header {
    border-bottom: 1px solid var(--yrm-border) !important;
    flex-shrink: 0 !important;
    background: var(--yrm-surface) !important;
  }
  
  .ant-drawer-body {
    flex: 1 !important;
    overflow-y: auto !important;
    padding: 24px !important;
  }
  
  .ant-drawer-footer {
    border-top: 1px solid var(--yrm-border) !important;
    flex-shrink: 0 !important;
    background: var(--yrm-surface) !important;
  }

  @media (max-width: 768px) {
    .ant-drawer {
      top: 56px !important;
      height: calc(100vh - 56px) !important;
    }
  }
`

export const TagPanel = styled.div`
  padding: 12px 14px;
  border: 1px solid var(--yrm-border);
  border-radius: 14px;
  background: var(--yrm-surface);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

  @media (max-width: 640px) {
    padding: 10px 12px;
    border-radius: 12px;
  }
`

export const TagHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: flex-start;
`

export const TagTitle = styled.div`
  min-width: 0;

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #102a43;
  }
`

export const TagList = styled.div`
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 28px;
  max-height: 92px;
  overflow: auto;
  padding-right: 4px;
`

export const TagEmptyState = styled.div`
  color: var(--yrm-text-4);
  font-size: 13px;
  padding: 4px 0;
`

export const TagFormGrid = styled.div`
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  align-items: stretch;
`

export const TagColorSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .tag-color-label {
    font-size: 12px;
    font-weight: 700;
    color: var(--yrm-text-2);
  }
`

export const TagColorGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
`

export const TagColorButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 999px;
  border: ${props => (props.$selected ? '2px solid #0f172a' : '1px solid rgba(15, 23, 42, 0.12)')};
  background-color: ${props => props.$color};
  box-shadow: ${props => (props.$selected ? '0 0 0 3px rgba(15, 23, 42, 0.08)' : 'none')};
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border 0.15s ease;

  &:hover {
    transform: translateY(-1px);
  }
`

export const TagInputSection = styled.div`
  .tag-input-label {
    display: block;
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 700;
    color: var(--yrm-text-2);
  }
`

export const TagActionButton = styled(Button)`
  min-width: 100%;
  border-radius: 10px !important;
  font-weight: 600 !important;
`

export const TagToggleButton = styled(Button)`
  border-radius: 999px !important;
  font-weight: 600 !important;
  padding-inline: 14px !important;
  height: 36px !important;
`

export const Status = styled.div`
  max-width: 400px;
  min-width: 140px;

  @media (max-width: 531px) {
    min-width: 95%;
  }
`

export const SelectStatus = styled(Select)`
  margin-top: 0.55rem;
  margin-bottom: 24px;
  width: 100%;

  @media (max-width: 531px) {
    margin-bottom: 12px;
  }
`

export const FooterContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: 5vh;
  gap: 8px;

  @media (max-width: 768px) {
    justify-content: center;
    height: auto;
    padding: 12px 0;
  }
`

export const FooterEditingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: 5vh;
  gap: 8px;

  @media (max-width: 768px) {
    justify-content: center;
    height: auto;
  }
`

export const StyledButton = styled(Button)`
  
  &.mobile-add-button {
    @media (max-width: 768px) {
      width: 200px;
      max-width: 300px;
    }
    
    @media (min-width: 769px) {
      flex: 1;
    }
  }
  
  &.mobile-update-button {
    @media (max-width: 768px) {
      max-width: 200px;
    }
    
    @media (min-width: 769px) {
      flex: 1;
    }
  }
`
